<template>
<div class="header-padding">
    <b-container class="my-3">
        <page-show :alias="'bunner'"></page-show>   
    </b-container>
</div>    
</template>

<script>
import PageShow from "@/components/components/PageShow";
export default {
    components:{
        'page-show':PageShow
    }
}
</script>

<style lang="scss">

</style>
